import { render, staticRenderFns } from "./ReopenJobs.vue?vue&type=template&id=588179ac&scoped=true&"
import script from "./ReopenJobs.vue?vue&type=script&lang=js&"
export * from "./ReopenJobs.vue?vue&type=script&lang=js&"
import style0 from "./ReopenJobs.vue?vue&type=style&index=0&id=588179ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588179ac",
  null
  
)

export default component.exports